export default "__VITE_ASSET__GtT2yuDW__"